export const DAG_HOVER_TRANSITION = 'transform 0.18s ease-out, background-color 0.18s ease-out, border-color 0.18s ease-out';
export const DAG_HOVER_TRANSFORM = 'translateY(-3px) scale(1.02)';
export const DAG_HOVER_SHADOW = '0 9px 24px rgba(87, 87, 176, 0.23), 0 4px 8px rgba(87, 87, 176, 0.13)';

const DAG_NON_SPINNER_SELECTOR = '*:not(.MuiCircularProgress-indeterminate):not(.MuiCircularProgress-circleIndeterminate)';

export const DAG_REDUCED_MOTION_STYLES = {
  [`& ${DAG_NON_SPINNER_SELECTOR}, & *::before, & *::after`]: {
    animationDuration: '0.01ms !important',
    animationIterationCount: '1 !important',
  },
  '& *, & *::before, & *::after': {
    transitionDuration: '0.01ms !important',
  },
};

// Scoped to DAG shapes: keep loading spinners and all interaction controls.
export const DAG_REDUCED_EFFECT_STYLES = {
  '& [data-project-dag-node], & [data-project-dag-node] *': {
    filter: 'none !important',
    backdropFilter: 'none !important',
    boxShadow: 'none !important',
    transition: 'none !important',
  },
  [`& [data-project-dag-node] ${DAG_NON_SPINNER_SELECTOR}`]: {
    animation: 'none !important',
  },
};
